import { z } from "src/lib";
import { OperacionLCSLHPTIFields, OperacionLCSLHPTITablaValorFields, OperacionLCSLHPTITablaValorHistoricoFields } from "./fields";
import { schemaEntityWithId, schemaEntityWithIdAndDescription } from "src/types";
import { OperacionAFOCLTablaValorHistoricoFields } from "../../afocl/types/fields";
import { schemaStringObligatorio, schemaStringOpcional } from "src/pages/sistema/types/types";

export const schemaOperacionLCSLHPTITablaValorInsert = z.object({
    [OperacionLCSLHPTITablaValorFields.IdOperacionLCSLHPTI]: z.number().nullable().optional(),
    [OperacionLCSLHPTITablaValorFields.CodInstrumento]: z.number(),
    [OperacionLCSLHPTITablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescInstrumento]: z.string(),
    [OperacionLCSLHPTITablaValorFields.Orden]: z.number(),
    [OperacionLCSLHPTITablaValorFields.Valor]: z.union([z.string(), z.number()], {
        invalid_type_error: 'El valor es requerido',
        required_error: 'El valor es requerido'
    }).nullable(),
});
export type OperacionLCSLHPTITablaValorInsert = z.infer<typeof schemaOperacionLCSLHPTITablaValorInsert>;

export const schemaOperacionLCSLHPTIInsert = z.object({
    [OperacionLCSLHPTIFields.CodPais]: z.number(),
    [OperacionLCSLHPTIFields.CodUnidadNegocio]: z.number().nullable(),
    // [OperacionLCSLHPTIFields.CodSectorComercial]: z.number(),
    [OperacionLCSLHPTIFields.FechaSolicitud]: z.date(),
    [OperacionLCSLHPTIFields.FechaVencimiento]: z.date(),
    [OperacionLCSLHPTIFields.Observaciones]: z.string().nullable().optional(),
    [OperacionLCSLHPTIFields.LimiteAgregadoPosicionComprada]: schemaStringObligatorio,
    [OperacionLCSLHPTIFields.LimiteAgregadoPosicionVendida]: schemaStringObligatorio,
    [OperacionLCSLHPTIFields.TablaValores]: z.array(schemaOperacionLCSLHPTITablaValorInsert),
});
export type OperacionLCSLHPTIInsert = z.infer<typeof schemaOperacionLCSLHPTIInsert>;

export const schemaOperacionLCSLHPTITablaValorUpdate = z.object({
    [OperacionLCSLHPTITablaValorFields.Valor]: z.union([z.string(), z.number()], {
        invalid_type_error: 'El valor es requerido',
        required_error: 'El valor es requerido'
    }).nullable(),
});
export type OperacionLCSLHPTITablaValorUpdate = z.infer<typeof schemaOperacionLCSLHPTITablaValorUpdate>;

export const schemaOperacionLCSLHPTITablaValorVista = z.object({
    [OperacionLCSLHPTITablaValorFields.IdOperacionLCSLHPTI]: z.number(),
    [OperacionLCSLHPTITablaValorFields.CodInstrumento]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescInstrumento]: z.string(),
    [OperacionLCSLHPTITablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescOperacionTipo]: z.string(),
    [OperacionLCSLHPTITablaValorFields.Valor]: z.union([z.string(), z.number()]),
    [OperacionLCSLHPTITablaValorFields.Orden]: z.number(),
    [OperacionLCSLHPTITablaValorFields.PermiteEditarInstrumento]: z.boolean(),
    [OperacionLCSLHPTITablaValorFields.Agrupacion]: z.string(),
    [OperacionLCSLHPTITablaValorFields.TipoSelector]: z.enum([
        'concentracion',
        'limite_perdida',
        'limite_holding',
        'limite_credito'
    ])
}).merge(schemaEntityWithId);
export type OperacionLCSLHPTITablaValorVista = z.infer<typeof schemaOperacionLCSLHPTITablaValorVista>;

export const schemaOperacionLCSLHPTITablaValorVistaInicial = z.object({
    [OperacionLCSLHPTITablaValorFields.CodInstrumento]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescInstrumento]: z.string(),
    [OperacionLCSLHPTITablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescOperacionTipo]: z.string(),
    [OperacionLCSLHPTITablaValorFields.Valor]: z.union([z.string(), z.number()]).nullable(),
    [OperacionLCSLHPTITablaValorFields.Orden]: z.number().nullable(),
    [OperacionLCSLHPTITablaValorFields.PermiteEditarInstrumento]: z.boolean(),
    [OperacionLCSLHPTITablaValorFields.Agrupacion]: z.string(),
    [OperacionLCSLHPTITablaValorFields.TipoSelector]: z.enum([
        'concentracion',
        'limite_perdida',
        'limite_holding',
        'limite_credito'
    ])
});
export type OperacionLCSLHPTITablaValorVistaInicial = z.infer<typeof schemaOperacionLCSLHPTITablaValorVistaInicial>;


// export const schemaOperacionLCSLHPTITablaValorHistorico = z.object({
//     [OperacionLCSLHPTITablaValorHistoricoFields.Id]: z.number(),
//     [OperacionLCSLHPTITablaValorHistoricoFields.CodInstrumento]: z.number(),
//     [OperacionLCSLHPTITablaValorHistoricoFields.CodOperacionTipo]: z.number(),
//     [OperacionLCSLHPTITablaValorHistoricoFields.InstrumentoNombre]: z.string(),
//     [OperacionLCSLHPTITablaValorHistoricoFields.Valor]: z.string(),
// });

export const schemaOperacionLCSLHPTITablaValorHistorico = schemaOperacionLCSLHPTITablaValorVista;

export type OperacionLCSLHPTITablaValorHistorico = z.infer<typeof schemaOperacionLCSLHPTITablaValorHistorico>;

export const schemaOperacionLCSLHPTITablaValorHistoricoGrupo = z.object({
    [OperacionLCSLHPTITablaValorHistoricoFields.FechaModificacion]: z.coerce.date(),
    [OperacionLCSLHPTITablaValorHistoricoFields.NombreUsuarioModificacion]: z.string(),
    [OperacionAFOCLTablaValorHistoricoFields.Observaciones]: z.string().nullable().optional(),
    [OperacionLCSLHPTITablaValorHistoricoFields.Celdas]: z.array(schemaOperacionLCSLHPTITablaValorHistorico)
});

export type OperacionLCSLHPTITablaValorHistoricoGrupo = z.infer<typeof schemaOperacionLCSLHPTITablaValorHistoricoGrupo>;

export const schemaFormUpdateLCSLHPTITablaValores = z.object({
    [OperacionLCSLHPTIFields.Observaciones]: schemaStringOpcional,
    [OperacionLCSLHPTIFields.TablaValores]: z.array(z.any()),
    [OperacionLCSLHPTIFields.LimiteAgregadoPosicionComprada]: z.string().optional(),
    [OperacionLCSLHPTIFields.LimiteAgregadoPosicionVendida]: z.string().optional(),
});

export type FormUpdateLCSLHPTITablaValores = z.infer<typeof schemaFormUpdateLCSLHPTITablaValores>;


export const schemaOperacionLCLSHPTILimiteTipo = z
    .object({

        [OperacionLCSLHPTIFields.Monto]: z.number(),
    })
    .merge(schemaEntityWithIdAndDescription)
export type OperacionLCLSHPTILimiteTipo = z.infer<typeof schemaOperacionLCLSHPTILimiteTipo>